import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userId: localStorage.getItem("userId") || 0, // 从 localStorage 中获取 userId
        username: localStorage.getItem("username") || "", // 从 localStorage 中获取 username
        token: localStorage.getItem("token") || "", // 从 localStorage 中获取 token
    },
    getters: {
        userId: (state) => state.userId,
        username: (state) => state.username,
        token: (state) => state.token,
    },
    mutations: {
        setUserId(state, userId) {
            state.userId = userId;
            localStorage.setItem("userId", userId);
        },
        setUsername(state, username) {
            state.username = username;
            localStorage.setItem("username", username);
        },
        setToken(state, token) {
            state.token = token;
            localStorage.setItem("token", token);
        },
    },
    actions: {
        setUserId({ commit }, userId) {
            commit("setUserId", userId);
        },
        setUsername({ commit }, username) {
            commit("setUsername", username);
        },
        setToken({ commit }, token) {
            commit("setToken", token);
        },
    },
    modules: {},
});
